exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".hidden-form[data-v-ad0ba558]{opacity:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-ad0ba558&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./app/components/HiddenInput.vue
// module id = 246
// module chunks = 0